﻿module.exports = (function ($, mustache, moment) {
    return {
        selectedTag: null,
        tagsBuilt: false,
        init: function () {
            // Used to reference 'this' inside anonymous functions (e.g. click events)
            var self = this;
            // If page has the calendar
            if ($('#calendar').length > 0)
                self.initCalendar();
        },
        initCalendar: function(){
            var self = this;
           
            // Init the open/close
            $('#hide_show_calendar').on('click', function () {

                $('.eventCalendar').slideToggle();
                $(this).toggleClass('hide');
                if ($(this).hasClass('hide'))
                    $(this).text('Show Calendar');
                else
                    $(this).text('Hide Calendar');
            });
            

            // Init the form filters
            $('#tags').on('change', function () {
                $('#calendar').fullCalendar('refetchEvents');
                self.selectedTag = $(this).val()
            });

            $('#aus_state').on('change', function () {
                $('#calendar').fullCalendar('refetchEvents');
            });

            $('#dates').change(function () {
                $('#calendar').fullCalendar('refetchEvents');
            });

            // inject a 'clear' button into the datepicker
            (function () {
                var old_fn = $.datepicker._updateDatepicker;
                $.datepicker._updateDatepicker = function (inst) {
                    old_fn.call(this, inst);
                    var buttonPane = $(this).datepicker("widget").find(".ui-datepicker-buttonpane");
                    $("<button type='button' class='ui-datepicker-clean ui-state-default ui-priority-primary ui-corner-all'>Clear</button>").appendTo(buttonPane).click(function (ev) {
                        $.datepicker._clearDate(inst.input);
                    });
                }
            })();

            // Init the datepicker
            $(function () {
                $("#dates").datepicker({
                    dateFormat: "dd/mm/yy",
                    showButtonPanel: true,
                    onSelect: function (d, i) {
                        // If value has change, fire event to reload events.
                        if(d !== i.lastVal){
                            $(this).change();
                        }
                    }
                });
            });

            // Init the calendar
            $('#calendar').fullCalendar({
                displayEventTime: false,
                showNonCurrentDates: false,
                fixedWeekCount:false,
                events: function (start, end, timezone, callback) {
                    var date = this.getDate()._d;
                    var firstDay = moment(new Date(date.getFullYear(), date.getMonth(), 1));
                    var lastDay = moment(new Date(date.getFullYear() + 10, date.getMonth() + 1, 1));
                    $.ajax({
                        url: '/umbraco/Api/eventsapi/search',
                        dataType: 'json',
                        method: 'POST',
                        data: {
                            state: $('#aus_state').val(),
                            tag: $('#tags').val(),
                            startDate: $("#dates").val() !== '' ? moment($("#dates").val(), 'DD/MM/YYYY').unix() : firstDay.unix(),
                            endDate: $("#dates").val() !== '' ? moment($("#dates").val(), 'DD/MM/YYYY').add(1, 'd').unix() : lastDay.unix(),
                            websiteId: $('#website_id').val()
                        },
                        success: function (data) {
                            
                            // Create event object array for calendar plugin
                            var events = [];
                            $(data.results).each(function (i, item) {
                                events.push({
                                    id: item.eventId,
                                    title: item.name,
                                    start: item.date,
                                    end: moment(item.endDate).add(1, 'd'), // add a day
                                    url: item.url,
                                    className: item.pinColour,
                                    textColor: '#fff'
                                });
                            });

                            callback(events);

                            // Create list below calendar.
                            self.createResultsList(data);

                            // Create the tag list (only once with full list);
                            self.tagsBuilt = false;
                            if (!self.tagsBuilt)
                                self.buildTagFilter(data);

                            // Set up the google maps.
                            if ($('.otherLocations__map').length > 0) {
                                $('.otherLocations__map').each(function () {
                                    self.createEventMap($(this).attr('data-lat'), $(this).attr('data-long'), $(this).attr('data-pin-colour'), $(this).attr('id'), $(this).attr('data-address'), 5);
                                });
                            }

                            
                        }
                    });
                }
            });

            $('.eventCalendar').hide();
            //$('#hide_show_calendar').text('Show Calendar').addClass('hide');
        },
        buildTagFilter: function (data) {
            var self = this;
            // Load up the tags filter with the tags from the 
            $('#tags').empty();
            $('#tags').append($('<option>', {
                value: '',
                text: 'All tags'
            }));
            console.log(self.selectedTag);
            $.each(data.tags, function (i, item) {
                $('#tags').append($('<option>', {
                    value: item,
                    text: item,
                    selected: (item == self.selectedTag)
                }));
            });
            
            self.tagsBuilt = true;
        },
        createResultsList: function (data) {
            if (data.resultsByMonth.length > 0)
            {
                // Populate search list template
                var template = $('#results-template').html();
                mustache.parse(template);
                var rendered = mustache.render(template, { items: data.resultsByMonth });
                $('#results').empty().html(rendered);
            }
            else {
                $('#results').empty().text('No events match the selected filters.');
            }
            
        },
        createEventMap: function (lat, lng, pinColour, mapElementId, address, zoom) {

            var iconUrl = window.location.protocol + "//" + window.location.hostname + "/assets/images/maps/retina/event-pin-" + pinColour + ".png";

            // Create new lat/long
            var latLng = new google.maps.LatLng(lat, lng);

            var mapOptions = {
                zoom: zoom,
                panControl: false,
                streetViewControl: false,
                fullscreenControl: false,
                mapTypeControl: false,
                scrollwheel: false,
                maxZoom: 16,
                center: latLng,
                zoomControl: false,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.TOP_LEFT
                },
                styles: [
                    {
                        "featureType": "administrative",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "off"
                            },
                            {
                                "color": "#95aabb"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#444444"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.province",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.province",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ababab"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#f2f2f2"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.man_made",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.man_made",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.man_made",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.natural.terrain",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f2f2f2"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "all",
                        "stylers": [
                            {
                                "saturation": -100
                            },
                            {
                                "lightness": 45
                            },
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "weight": "1"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            },
                            {
                                "weight": "1.5"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            },
                            {
                                "weight": "0.25"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            },
                            {
                                "weight": "1.15"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#46bcec"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#95aabb"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ffffff"
                            }
                        ]
                    }
                ]
            };

            // Set up google map
            var map = new google.maps.Map(document.getElementById(mapElementId), mapOptions);

            // Build a marker image of retina compatibility
            var mapIcon = {
                url: iconUrl,
                anchor: new google.maps.Point(22, 59.5),
                scaledSize: new google.maps.Size(58, 59.5)
            };

            google.maps.event.addDomListener(window, "resize", function () {
                google.maps.event.trigger(map, "resize");
            });

            function callback(results, status) {
                if (status === google.maps.places.PlacesServiceStatus.OK) {
                    for (var i = 0; i < results.length; i++) {
                        createMarker(results[i]);
                    }
                }
            }

            function createMarker(place) {
                var marker = new google.maps.Marker({
                    map: map,
                    icon: mapIcon, // Get a custom one made
                    position: place.geometry.location,
                    url: 'https://www.google.com/maps/search/?api=1&zoom=16&query=' + place.geometry.location.lat() + ',' + place.geometry.location.lng() + '&query_place_id=' + place.place_id
                });
                map.setCenter(place.geometry.location);
                google.maps.event.addListener(marker, 'click', function () {
                    window.open(this.url, '_blank');
                });
            }

            if (address) {
                var request = {
                    location: map.getCenter(),
                    radius: '500',
                    query: address
                };

                var service = new google.maps.places.PlacesService(map);
                service.textSearch(request, callback);
            }
            else {
                // Add marker
                var marker = new google.maps.Marker({
                    position: latLng,
                    map: map,
                    icon: mapIcon, // Get a custom one made
                    url: 'https://www.google.com/maps/search/?api=1&zoom=16&query=' + latLng.lat() + ',' + latLng.lng()
                });

                google.maps.event.addListener(marker, 'click', function () {
                    window.open(this.url, '_blank');
                });
            }
        }
    }
});